const { isEmpty } = require('lodash');

const fields = () => {
  return {
    title: {
      type: 'string',
      label: 'タイトル',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    image: {
      type: 'files',
      label: '画像',
      accept: 'image/*',
      validations: {
        required: v => v != null && (v.downloadUrl != null || v.length > 0),
      },
    },
    publishedAt: {
      type: 'date',
      label: '掲載開始日',
      validations: {
        required: v => v != null,
      },
    },
    popupStartAt: {
      type: 'date',
      label: 'ポップアップ開始日',
      hint: '設定するとログイン後にポップアップ表示されます',
    },
    popupEndAt: {
      type: 'date',
      label: 'ポップアップ終了日',
      hint: '終了日を過ぎるとポップアップ表示されなくなります',
    },
  };
};

module.exports = {
  fields,
};
